// extracted by mini-css-extract-plugin
export default {"main":"styles_main__Dws6Q","main_container":"styles_main_container__yBE+z","btn_download":"styles_btn_download__dah86","btn_download_text":"styles_btn_download_text__AW3hQ"};